import getFetchOptions from './utils/getFetchOptions.js';
import fetchJSON from './utils/fetchJSON.js';
function creditVerificationFetcher(path) {
  return {
    path: path + 'cars-for-sale/creditverfication',
    async fetch() {
      let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const options = {
        body: data,
        method: 'POST',
        circuitBreaker: {
          id: 'creditverification',
          timeout: 15000,
          // 15 seconds timeout to allow for lambda cold start
          resetTimeout: 10000,
          // reduce to 10 seconds so that user can resubmit after making changes
          fallback: {
            error: 'Circuit Breaker for /creditverification is open'
          }
        },
        headers: {
          'Content-Type': 'text/plain',
          'X-fwd-svc': 'atc'
        }
      };
      try {
        const responseData = await fetchJSON(this.path, getFetchOptions(options));
        return responseData;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching credit verification details: ', error);
      }
      return {};
    }
  };
}
export { creditVerificationFetcher as default };
